module.exports = __webpack_public_path__ + "img/down.8459c483.svg";